<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import _ from "lodash";

export default {
  name: "TheEditAvatarDialog",

  props: {
    dialog: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      fileAvatarChange: null,
      allowedTypes: ".jpg, .jpeg, .png",
      avatarFileRules: [
        v=> !!v || 'Обязательное поле.',
        v => (v && v.size <= 2048 * 1024) || 'Размер файла должен быть не более 2MB.',
        v => {
          if (!v) return true;
          const allowedFormats = ['image/png', 'image/jpeg', 'image/jpg'];
          return allowedFormats.includes(v.type) || 'Доступны только PNG и JPEG файлы.';
        }
      ],

    }
  },

  watch: {
    fileAvatarChange: function () {
      this.setPortfolioAvatar(this.fileAvatarChange);
    }
  },

  computed: {
    ...mapGetters({
      urlPhotoPortfolio: "portfolio/urlPhotoPortfolio",
    }),

    avatarSrc() {
      if (_.isNil(this.fileAvatarChange)) return this.urlPhotoPortfolio;
      else return URL.createObjectURL(this.fileAvatarChange);
    },

    show: {
      get () {
        return this.dialog
      },
      set (value) {
        if (!value) {
          this.setPortfolioAvatar(null);
          this.$emit('close')
        }
      }
    },

  },

  methods: {
    ...mapMutations({
      setPortfolioAvatar: "portfolio/setPortfolioAvatar",
    }),

    ...mapActions({
      editAvatarPortfolio: "portfolio/editAvatarPortfolio",
    }),

    async submitNewAvatarPortfolio() {
      await this.editAvatarPortfolio();
      this.show = false;
    },

  },
}
</script>

<template>
  <v-dialog
    v-model="show"
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '465px'"
    content-class="rounded-xl overflow-hidden"
  >
    <v-card class="rounded-xl" style="z-index: 25">

      <v-card-title>
        Смена аватара профиля
      </v-card-title>
      <v-card-text>

        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <v-avatar size="100" style="border: 2px #e2e2e2 solid">
              <v-img
                :src="avatarSrc"
              >
              </v-img>
            </v-avatar>
          </v-col>
        </v-row>

        <v-form>
          <v-row>
            <v-col>
              <v-file-input
                label="Аватар"
                v-model="fileAvatarChange"
                outlined
                class="rounded-xl"
                dense
                :rules="avatarFileRules"
                :accept="allowedTypes"
              >

              </v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn
          class="rounded-xl"
          :color="$store.state.achievement.side_color"
          outlined
          @click="show = false"
        >
          Отмена
        </v-btn>
        <v-btn
          class="white--text rounded-xl"
          :color="$store.state.achievement.side_color"
          @click="submitNewAvatarPortfolio"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<style scoped>

</style>